import React from "react";

const AppLogo = () => {
  return <img src="/static/logo.svg" alt="qxp" height={80} />;
};

export default AppLogo;
